import { Alert } from 'antd';
import { useEffect, useRef, useState } from 'react';

export const useTour = flag => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [allowNextStep, setAllowNextStep] = useState(false);

  const translationsListRef = useRef(null);
  const translationsChooseRef = useRef(null);
  const translationsGridRef = useRef(null);
  const translationsAIRef = useRef(null);
  const translationsFullScreenRef = useRef(null);

  useEffect(() => {
    setAllowNextStep(flag);
  }, [flag]);

  const steps = [
    {
      title: 'Страница трансляций',
      description: (
        <>
          <div>
            Добро пожаловать в раздел «Трансляции» — здесь вы в режиме реального времени контролируете видеопотоки с
            устройств. Настройте удобную сетку просмотра, включите нейросетевой анализ и держите ситуацию под полным
            визуальным контролем.
          </div>
          {!allowNextStep && (
            <Alert message={'Чтобы продолжить тур запустите трансляцию!'} style={{ marginTop: '10px' }} />
          )}
        </>
      ),
      target: null,
    },
    {
      title: 'Список трансляций',
      description: 'На главном экране отображаются все активные видеопотоки с устройств вашего контура.',
      target: null,
    },
    {
      title: 'Выбор трансляций',
      description:
        'Отметьте необходимые трансляции, чтобы видеть только важные для вас потоки. По умолчанию отображаются все доступные трансляции.',
      target: () => translationsChooseRef.current,
    },
    {
      title: 'Выбор сетки трансляций',
      description: 'Подберите удобный формат отображения трансляций — одно или несколько окон на экране.',
      target: () => translationsGridRef.current,
    },
    {
      title: 'Выбор режима нейросети',
      description:
        'Включите нейросетевой режим для автоматического распознавания стратегически важных объектов в трансляциях. Просто активируйте переключатель, и система начнёт анализ в реальном времени.',
      target: () => translationsAIRef.current,
    },
    {
      title: 'Полноэкранный	режим',
      description: 'Нажмите на трансляцию, чтобы увеличить изображение или переключиться в полноэкранный режим.',
      target: null,
    },
  ];

  const startTour = () => {
    setCurrentStep(0);
    setIsTourOpen(true);
  };

  const handleTourChange = nextStep => {
    if (!allowNextStep) {
      return;
    }

    setCurrentStep(nextStep);
  };

  const handleClose = () => {
    setIsTourOpen(false);
  };

  return {
    isTourOpen,
    currentStep,
    handleClose,
    steps,
    startTour,
    handleTourChange,
    setAllowNextStep,
    translationsListRef,
    translationsChooseRef,
    translationsGridRef,
    translationsAIRef,
    translationsFullScreenRef,
  };
};
